/** Each tab is its own route, `/integrations/<tab>` (CLAUDE.md → Tabs are routes); the install, edit and map sheets are routes under their tab. */
export const INTEGRATION_TABS = ['catalogue', 'installed', 'device-mappings'] as const;
export type IntegrationTab = (typeof INTEGRATION_TABS)[number];

export const INTEGRATION_TAB_LABELS: Record<IntegrationTab, string> = { catalogue: 'Catalogue', installed: 'Installed', 'device-mappings': 'Device mappings' };

export function integrationTabPath(tab: IntegrationTab): string {
  return `/integrations/${tab}`;
}

export function installIntegrationPath(adapterKey: string): string {
  return `/integrations/installed/new?adapter=${encodeURIComponent(adapterKey)}`;
}

export function integrationPath(id: string): string {
  return `/integrations/installed/${id}`;
}

export const NEW_DEVICE_MAPPING_PATH = '/integrations/device-mappings/new';
